export const SET_REVIEW = 'SET_REVIEW'
export const UPDATA_FOLLOW = 'UPDATA_FOLLOW'
export const UPDATA_LOAD = 'UPDATA_LOAD'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js